"use client"

import styled from "styled-components"

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols || 1}, 1fr);
  gap: ${({ $gap, theme }) => $gap || theme.grid.gap.md};
  
  /* Responsive breakpoints */
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(${({ $xlCols, $cols }) => $xlCols || Math.min($cols || 1, 3)}, 1fr);
    gap: ${({ $xlGap, $gap, theme }) => $xlGap || $gap || theme.grid.gap.md};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(${({ $lgCols, $xlCols, $cols }) => $lgCols || $xlCols || Math.min($cols || 1, 2)}, 1fr);
    gap: ${({ $lgGap, $xlGap, $gap, theme }) => $lgGap || $xlGap || $gap || theme.grid.gap.sm};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(${({ $mdCols, $lgCols }) => $mdCols || $lgCols || 2}, 1fr);
    gap: ${({ $mdGap, $lgGap, theme }) => $mdGap || $lgGap || theme.grid.gap.sm};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(${({ $smCols, $mdCols }) => $smCols || $mdCols || 1}, 1fr);
    gap: ${({ $smGap, $mdGap, theme }) => $smGap || $mdGap || theme.grid.gap.xs};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    grid-template-columns: 1fr;
    gap: ${({ $xsGap, $smGap, theme }) => $xsGap || $smGap || theme.grid.gap.xs};
  }
`

const ResponsiveGrid = ({
  children,
  cols = 1,
  xlCols,
  lgCols,
  mdCols,
  smCols,
  xsCols,
  gap,
  xlGap,
  lgGap,
  mdGap,
  smGap,
  xsGap,
  className,
  ...props
}) => {
  return (
    <Grid
      $cols={cols}
      $xlCols={xlCols}
      $lgCols={lgCols}
      $mdCols={mdCols}
      $smCols={smCols}
      $xsCols={xsCols}
      $gap={gap}
      $xlGap={xlGap}
      $lgGap={lgGap}
      $mdGap={mdGap}
      $smGap={smGap}
      $xsGap={xsGap}
      className={className}
      {...props}
    >
      {children}
    </Grid>
  )
}

export default ResponsiveGrid
